<template>
  <div>
    <a-modal v-model:visible="visible" title="五行" @ok="handleOk" okText="确认" cancelText="取消" :afterClose="closeModal" :cancelButtonProps="{ style: { display: 'none' }}" width="55vw">

      <table>
        <thead>
          <tr>
            <th></th>
            <th>阳</th>
            <th>阴</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in data" :key="item.name">
            <td>{{ item.name }}</td>
            <td>
              <a-checkbox @change="handleCheckChange(item, 'yang')" v-model:checked="item.yangChecked">{{ item.yang }}</a-checkbox>
            </td>
            <td>
              <a-checkbox @change="handleCheckChange(item, 'yin')" v-model:checked="item.yinChecked">{{ item.yin }}</a-checkbox>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- <div style="text-align: center;margin-top: 20px;">
        <a-button type="primary" @click="visible2=true">新增权限</a-button>
      </div> -->
    </a-modal>
  </div>
  <!-- <addPrescription v-model="visible2" @getData="callbackData" /> -->
</template>

<script>
import { reactive } from "vue";
import { GetWuxing, GetPulse } from "/src/api/medicalRecord.js";
export default {
  components: {
  },
  data() {
    return {
      visible: this.modelValue,
      selectedRows: {},
      columns: [],
      data: [],
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
    };
  },
  emits: ['update:modelValue'],
  created() {

  },
  mounted() {
    this.detail()
  },
  activated() {
  },
  //获取父元素传值
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
  },
  methods: {
    async detail() {
      let res = await GetWuxing()
      let res2 = await GetPulse()

      if (res.errCode == 0 && res2.errCode == 0) {
        this.columns = res.data; // ["金", "木", "水", "火", "土"]

        const pulseList = res2.data;
        const grouped = {};

        // 将脉象按照 wuxing 分组
        pulseList.forEach(item => {
          if (!grouped[item.wuxing]) {
            grouped[item.wuxing] = {};
          }
          grouped[item.wuxing][item.yinyang] = item.pulse;
        });

        this.data = this.columns.map(wuxing => ({
          name: wuxing,
          yang: grouped[wuxing]?.阳 || '-',
          yin: grouped[wuxing]?.阴 || '-',
          yangChecked: false, // 默认不勾选
          yinChecked: false, // 默认不勾选
        }));
      } else {
        this.$message.error("数据加载失败");
      }
    },
    handleCheckChange(item, type) {


      console.log(item, type);
      //同行的yang和yin只能选一个
      if (type === 'yang') {
        item.yinChecked = false
      } else if (type === 'yin') {
        item.yangChecked = false
      }

      // if (item.yangChecked && item.yinChecked) {
      //   item.yinChecked = false
      // } else if (!item.yangChecked && !item.yinChecked) {
      //   item.yangChecked = true
      // }
    },
    async handleOk() {
      let _this = this;
      let checked = []
      this.data.forEach(item => {
        if (item.yangChecked) {
          checked.push(item.yang)
        }
        if (item.yinChecked) {
          checked.push(item.yin)
        }
      })

      this.$emit("wuxingCallback", checked);

      this.closeModal()

    },
    async onDelete(id) {

      let res = await Delete({ id })
      if (res.errCode == 0) {
        this.data = this.data.filter(function (item) {
          return item.id !== id;
        });
      }

    },
    closeModal() {
      this.$emit('update:modelValue', false);
    },

  },
  watch: {

    modelValue(val) {
      this.visible = val
    },
  }
};
</script>

<style scoped>
.head {
  display: flex;
  justify-content: center;
  align-items: center;
}
.head span {
  font-weight: bold;
  margin-right: 10px;
}
.head2 {
  display: flex;
  margin-bottom: 20px;
  justify-content: center;
  align-items: center;
}
.head2 span {
  font-weight: bold;
  margin-right: 10px;
}
table {
  width: 80%;
  margin: 0 auto;
  background-color: #f5f5f5;
}
th,
td {
  text-align: center;
  padding: 10px;
}
</style>